import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedActivityGroupModalModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add an activity groups"
    okText="ADD ACTIVITY GROUP"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose an activity groups"
      queryVariables={{ typeId: FILTER_TYPE.SKILL.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Activity groups is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedActivityGroupModalModal.Item = Item;

export default RelatedActivityGroupModalModal;
